<jhi-alert-overlay />
<div
    id="page-wrapper"
    class="page-wrapper"
    [ngClass]="{ 'no-padding': isShownViaLti }"
    [ngStyle]="{ 'overflow-y': !isTestRunExam && isExamStarted ? 'hidden' : 'auto' }"
    cdkScrollable
>
    <jhi-page-ribbon />
    @if (showSkeleton && !isShownViaLti) {
        <div class="sticky-top-navbar">
            <router-outlet name="navbar" />
        </div>
    }
    @if (showSkeleton) {
        <div>
            <div [ngClass]="{ 'module-bg m-3 mb-5 p-3 mt-0 rounded rounded-3': usesModuleBackground }">
                <router-outlet />
            </div>
        </div>
    } @else {
        <router-outlet />
    }
    <jhi-course-notification-popup-overlay />
    @if (showSkeleton && !isShownViaLti) {
        @if (isTestRunExam || !isExamStarted) {
            <jhi-footer />
        }
    }
</div>
